import React from "react";

import CircularProgress from '@material-ui/core/CircularProgress'
import MuiAlert from '@material-ui/lab/Alert';
import Snackbar from '@material-ui/core/Snackbar';
import { } from "pages/redux/actions";
import axios from 'axios';
import logo from 'assets/img/defu.png';
import Avatar from '@material-ui/core/Avatar';
import logo2 from 'assets/img/ld.gif';
import { connect } from 'react-redux';
// reactstrap components
import {
    Button,
    Card,
    CardHeader,
    CardFooter,
    CardBody,
    FormGroup,
    Form,
    Input,
    Container,
    Row,
    Col,
} from "reactstrap";
// core components
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import UserHeader from "components/Headers/UserHeader.js";
// import { Modal } from "bootstrap";
const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        large: {
            width: theme.spacing(40),
            height: theme.spacing(40),
        },
    }),
);
const Profile = (props) => {
    const [bgImage, setbgImage] = React.useState(logo);
    const [userd, setuserd] = React.useState({});
    const ref = React.useRef()
    const classes = useStyles();
    const [pass, setpass] = React.useState({ 'old': '', 'new': '' });
    const [passcontent, setpasscontent] = React.useState('Change');
    const [editcontent, seteditcontent] = React.useState('Save');
    const [sendingdata, setSendingdata] = React.useState('');
    const [tt, settt] = React.useState('');
    const [open, setOpen] = React.useState(false);
    const edit = React.useState(true);
    const fetchData = React.useCallback(() => {
        // console.log('fetching')
        axios.get(process.env.REACT_APP_DOMAIN+"/profile", { 'headers': { 'Authorization': 'Token ' + props.token } })
            .then((response) => {
                // console.log(response.data)
                // console.log(response.data)
                // console.log('entered')
                setuserd(response.data)
                // console.log(response.data)
                if (response.data.photo != null) {
                    var phurl = process.env.REACT_APP_DOMAIN+'' + response.data.photo;
                    // console.log(phurl)
                    setbgImage(phurl);
                }
            })
            .catch((error) => {
                setSendingdata('Something went wrong, Please Try Again')
                settt('error')
                setOpen(true);
            })
    }, [props.token])
    React.useEffect(() => {
        fetchData()
    }, [fetchData])

    const handleClose = (event, reason) => {
        setOpen(false);
    };

    const handleProfilePic = () => {
        ref.current.click()
    };

    const handleProChange = (event) => {
        setbgImage(logo2)
        // setpro(event.target.files[0])
        // console.log('step 1')
        let formdata = new FormData();
        // console.log(formdata)
        if (event.target.files[0] === undefined) {
            setSendingdata('Please add poster')
            settt('error')
            setOpen(true)
            return 0;
        }
        // else {

        // console.log('step 2')
        formdata.append('profile', event.target.files[0], event.target.files[0].name)
        // }
        // console.log(formdata)
        // for (var pair of formdata.entries()) {
        //     console.log(pair[0] + ', ' + pair[1]);
        // }
        // console.log(formdata)
        // console.log('step 3')
        axios.post(process.env.REACT_APP_DOMAIN+'/addprofile', formdata, { 'headers': { 'Authorization': 'Token ' + props.token, 'Content-type': 'multipart/form-data' } })
            .then((response) => {
                // console.log(response.data)
                // setbgImage(URL.createObjectURL(event.target.files[0]))
                setSendingdata('Profile Pic Successfully Changed')
                settt('success')
                setOpen(true)
                fetchData()
            })
            .catch((error) => {
                console.log(error)
                setOpen(true)
                setSendingdata('Something went wrong')
                settt('error')
            })
    };


    const handleUChange = (event) => {
        setuserd({ ...userd, [event.target.name]: event.target.value })
    };

    const handlePassChange = (event) => {
        setpass({ ...pass, [event.target.name]: event.target.value })
    };

    const handleChangePass = () => {
        if (passcontent === 'Change') {
            setpasscontent(<CircularProgress size="20px" style={{ color: '#172b4d' }} />)
            if (pass.old === undefined) {
                setOpen(true)
                setSendingdata('Please add Current Password')
                settt('error')
                setpasscontent('Change')
                return 0;
            }
            if (pass.new === undefined) {
                setOpen(true)
                setSendingdata('Please add New Password')
                settt('error')
                setpasscontent('Change')
                return 0;
            }
            if (pass.old.length < 1) {
                setOpen(true)
                setSendingdata('Please add Current Password')
                settt('error')
                setpasscontent('Change')
                return 0;
            }
            if (pass.new.length < 1) {
                setOpen(true)
                setSendingdata('Please add New Password')
                settt('error')
                setpasscontent('Change')
                return 0;
            }
            // console.log(pass)
            axios.post(process.env.REACT_APP_DOMAIN+'/changepassword', pass, { 'headers': { 'Authorization': 'Token ' + props.token } })
                .then((response) => {
                    // console.log(response.data)
                    // setbgImage(URL.createObjectURL(event.target.files[0]))
                    // fetchData()
                    if (response.data.status === 404) {
                        setOpen(true)
                        setSendingdata('Old Password is wrong')
                        settt('error')
                    }
                    else {
                        setpass({ 'old': '', 'new': '' })
                        setOpen(true)
                        setSendingdata('Password Successfully Changed')
                        settt('success')
                    }
                    setpasscontent('Change')
                })
                .catch((error) => {
                    console.log(error)
                    setOpen(true)
                    setSendingdata('Something went wrong')
                    settt('error')
                })
        }
        else {
            setpasscontent('Change')
            // if (pass.old === undefined) {
            //     setOpen(true)
            //     setSendingdata('Please add Current Password')
            //     settt('error')
            //     setpasscontent('Change')
            //     return 0;
            // }
            // if (pass.new === undefined) {
        }

    };

    const handleChangeEdit = () => {
        if (editcontent === 'Save') {
            seteditcontent(<CircularProgress size="20px" style={{ color: '#172b4d' }} />)
            setOpen(true)
            setSendingdata('Please wait a sec')
            settt('success')
            axios.post(process.env.REACT_APP_DOMAIN+'/editprofile', userd, { 'headers': { 'Authorization': 'Token ' + props.token } })
                .then((response) => {
                    // console.log(response.data)
                    // setbgImage(URL.createObjectURL(event.target.files[0]))
                    setSendingdata('Successfully Saved')
                    settt('success')
                    setOpen(true)
                    seteditcontent('Save')
                    fetchData()

                })
                .catch((error) => {
                    console.log(error)
                    setOpen(true)
                    seteditcontent('Save')
                    setSendingdata('Something went wrong')
                    settt('error')
                })
        }
        else {
            seteditcontent('Save')
        }

    };
    console.log(bgImage)
    return (
        <>
            <UserHeader id={props.username}/>
            {/* Page content */}
            <Container className="mt--3" fluid>
                <Row>
                    <Col className="order-xl-1" xl="8">
                        <Card className="bg-secondary shadow">
                            <Row className="justify-content-center">
                                <Col className="order-lg-2 mt--3" lg="3">
                                    <div className="card-profile-image point bg-pinkc" onClick={handleProfilePic} style={{ borderRadius: '500px',zIndex: 9 }} >
                                        <Avatar src={bgImage} style={{ zIndex: 12, backgroundColor: '#f8f9fe', maxWidth: '200px', maxHeight: '200px', paddingTop: '100px' }} className={classes.large + ' rounded-circlec'} ></Avatar>
                                        <input type="file" accept="*image" ref={ref} onChange={handleProChange} style={{ display: 'none' }} />
                                    </div>
                                </Col>
                            </Row>
                            <CardHeader className="bg-white border-0">
                                <Row className="align-items-center">
                                    <Col xs="8">
                                        <h3 className="mb-0">Your Profile</h3>
                                    </Col>
                                    {/* <Col className="text-right" xs="4">
                                        {!edit &&
                                            <Button color="primary" onClick={(e) => setedit(!edit)} size="sm" >Edit</Button>
                                        }
                                        {edit &&
                                            <Button color="primary" onClick={(e) => setedit(!edit)} size="sm">Cancel</Button>
                                        }
                                    </Col> */}
                                </Row>
                            </CardHeader>
                            <CardBody>
                                <Form>
                                    <h6 className="heading-small text-muted mb-4">Main info</h6>
                                    <div className="pl-lg-4">
                                        <Row>
                                            <Col lg="6">
                                                <FormGroup>
                                                    <label className="form-control-label" htmlFor="input-username-og">Username</label>
                                                    <Input className="form-control-alternative" onChange={handleUChange} name="username" value={userd.username} disabled={!edit} id="input-username-og" placeholder="Username" type="text" />
                                                </FormGroup>
                                            </Col>
                                            <Col lg="6">
                                                <FormGroup>
                                                    <label className="form-control-label" htmlFor="input-email-og">Email address</label>
                                                    <Input className="form-control-alternative" onChange={handleUChange} name="email" value={userd.email} disabled={!edit} id="input-email-og" placeholder="Email Address" type="email" />
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col lg="6">
                                                <FormGroup>
                                                    <label className="form-control-label" htmlFor="input-first-name">First name</label>
                                                    <Input className="form-control-alternative" onChange={handleUChange} name="first_name" value={userd.first_name} disabled={!edit} id="input-first-name" placeholder="First name" type="text" />
                                                </FormGroup>
                                            </Col>
                                            <Col lg="6">
                                                <FormGroup>
                                                    <label className="form-control-label" htmlFor="input-last-name">Last name</label>
                                                    <Input className="form-control-alternative" onChange={handleUChange} name="last_name" value={userd.last_name} disabled={!edit} id="input-last-name" placeholder="Last name" type="text" />
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                    </div>
                                    <hr className="my-4" />




                                    <h6 className="heading-small text-muted mb-4">Account Details</h6>
                                    <div className="pl-lg-4">
                                        <Row>
                                            <Col lg="6">
                                                <FormGroup>
                                                    <label className="form-control-label" htmlFor="input-type-og">Account Type</label>
                                                    <Input className="form-control-alternative" name="type" value={userd.type} disabled={!edit} id="input-type-og" placeholder="Account Type" type="select" >
                                                        <option value="Student">Student</option>
                                                        <option value="Faculty">Faculty</option>
                                                        <option value="SuperAdmin">Super-Admin</option>
                                                    </Input>
                                                </FormGroup>
                                            </Col>
                                            <Col lg="6">
                                                <FormGroup>
                                                    <label className="form-control-label" htmlFor="input-idno-og">ID No</label>
                                                    <Input className="form-control-alternative" onChange={handleUChange} name="idno" value={userd.idno} disabled={!edit} id="input-idno-og" placeholder="ID No" type="text" />
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col lg="6">
                                                <FormGroup>
                                                    <label className="form-control-label" htmlFor="input-department-name">Department</label>
                                                    <Input className="form-control-alternative" onChange={handleUChange} name="department" value={userd.department} disabled={!edit} id="input-department-name" placeholder="Department" type="text" />
                                                </FormGroup>
                                            </Col>
                                            {(userd.is_staff ?
                                            <Col lg="6">
                                                <FormGroup>
                                                    <label className="form-control-label" htmlFor="input-designation-name">Designation</label>
                                                    <Input className="form-control-alternative" onChange={handleUChange} name="designation" value={userd.designation} disabled={!edit} id="input-designation-name" placeholder="Designation" type="text" />
                                                </FormGroup>
                                            </Col>
                                            :
                                            <Col lg="6" className="">
                                                <Row>
                                                <Col lg="6">
                                                    <FormGroup>
                                                        <label className="form-control-label" htmlFor="input-year-name">Year</label>
                                                                <Input className="form-control-alternative" onChange={handleUChange} name="year" value={userd.year} disabled={!edit} id="input-year-name" placeholder="Year" type="select" >
                                                                <option value="FE">FE</option>
                                                                    <option value="SE">SE</option>
                                                                    <option value="TE">TE</option>
                                                                    <option value="BE">BE</option>
                                                    </Input>
                                                    </FormGroup>
                                                </Col><Col lg="6">
                                                <FormGroup>
                                                    <label className="form-control-label" htmlFor="input-division-name">Division</label>
                                                    <Input className="form-control-alternative" onChange={handleUChange} name="division" value={userd.division} disabled={!edit} id="input-division-name" placeholder="Division" type="text" />
                                                </FormGroup>
                                                </Col></Row>
                                            </Col>
                                            )}
                                            
                                        </Row>
                                    </div>
                                    {/* <hr className="my-4" /> */}





                                    {/* <h6 className="heading-small text-muted mb-4">Additional Details <span className="text-capitalize text-red">( Not visible to Others )</span></h6>
                                    <div className="pl-lg-4">
                                        <Row>
                                            <Col lg="6">
                                                <FormGroup>
                                                    <label className="form-control-label" htmlFor="input-phone-og">Recovery Phone</label>
                                                    <Input className="form-control-alternative" onChange={handleUChange} name="contactinfo2" value={userd.contactinfo2} disabled={!edit} id="input-phone-og" placeholder="Contact Info 2" type="text" />
                                                </FormGroup>
                                            </Col>
                                            <Col lg="6">
                                                <FormGroup>
                                                    <label className="form-control-label" htmlFor="input-email-by">Recovery Email</label>
                                                    <Input className="form-control-alternative" onChange={handleUChange} name="email2" value={userd.email2} disabled={!edit} id="input-email-by" placeholder="Email Address" type="email" />
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                    </div> */}
                                </Form>
                            </CardBody>
                            <CardFooter>
                                <div className="text-center">
                                    <Button
                                        color="info"
                                        disabled={!edit}
                                        outline
                                        onClick={handleChangeEdit}
                                    >
                                        {editcontent}
                                    </Button>
                                </div>
                            </CardFooter>
                        </Card>
                    </Col>
                    <Col className="order-xl-2 mb-5 mb-xl-0 mobile-sm-mt" xl="4">
                        <Card className="card-profile shadow">
                            <CardHeader className="pt-md-4 pb-4 pb-md-4">
                                <Row className="bg-gradient-infoe mb-0"><Col className="bg-gradient-yellowe" lg={12} sm={12}><h3 className="mb-0">Change Password</h3></Col></Row>
                            </CardHeader>
                            <CardBody className="pt-0 pt-md-4 pr-0 pl-4">
                                <Row className="text-center justify-content-center bg-gradient-yellowv mr-0" style={{ width: '100%' }}>
                                    <Col lg="10">
                                        <FormGroup>
                                            <label className="form-control-label mt-3" htmlFor="input-username">Old Password</label>
                                            <Input className="form-control-alternative mt-3" id="input-username" placeholder="Enter Current Password" type="password" value={pass.old} onChange={handlePassChange} name="old" />
                                        </FormGroup>
                                    </Col>
                                    <Col lg="10">
                                        <FormGroup>
                                            <label className="form-control-label mt-3" htmlFor="input-email" >New Password</label>
                                            <Input className="form-control-alternative mt-3" id="input-email" placeholder="Enter New Password" type="password" value={pass.new} onChange={handlePassChange} name="new" />
                                        </FormGroup>
                                    </Col>
                                </Row>
                            </CardBody>
                            <CardFooter>
                                <div className="text-center">
                                    <Button color="info" outline onClick={handleChangePass} >{passcontent}</Button>
                                </div>
                            </CardFooter>
                        </Card>
                    </Col>
                </Row>
                <Snackbar anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }} open={open} autoHideDuration={6000} onClose={handleClose}>
                    <MuiAlert elevation={6} variant="filled" onClose={handleClose} severity={tt}>{sendingdata}</MuiAlert>
                </Snackbar>
            </Container>
        </>
    );
};


export const mapStateToProps = state => {
    // console.log("this is the state", state);
    return {
        adminValue: state.switchRoutes.admin,
        userValue: state.switchRoutes.user,
        username: state.userName,
        token: state.token,
    }
}

export default connect(mapStateToProps)(Profile);
